import { render, staticRenderFns } from "./QuoteExpiredLabel.vue?vue&type=template&id=5da73239&"
import script from "./QuoteExpiredLabel.vue?vue&type=script&lang=ts&"
export * from "./QuoteExpiredLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports